import { render, staticRenderFns } from "./banco_escuelas.vue?vue&type=template&id=79bd6f5a&"
import script from "./banco_escuelas.vue?vue&type=script&lang=js&"
export * from "./banco_escuelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports